import { type SvgIcon, type SvgIconProps, Typography } from '@mui/material';

interface Props {
  icon: typeof SvgIcon;
  iconSize?: SvgIconProps['fontSize'];
  label: string;
}

export function FilterHeading({ icon: Icon, iconSize, label }: Props) {
  return (
    <Typography
      variant="subtitle1"
      component="h2"
      sx={{ display: 'flex', alignItems: 'center', mb: 2 }}
    >
      <Icon color="action" sx={{ mr: 1 }} fontSize={iconSize} />
      {label}
    </Typography>
  );
}
